import React from "react"
import { Grid, Typography, Paper } from "@mui/material"
import Main from "./components/Main"

const posts = [
  <Paper
    elevation={0}
    sx={{
      my: 2,
      p: 2,
      bgcolor: "grey.200",
    }}>
    <Typography variant="h6" gutterBottom paragraph>
      Bookay (www.bookay-buecher.de)
    </Typography>
    <Typography>
      <h2>Allgemeine Geschäftsbedingungen</h2>
      <h3>Geltungsbereich</h3>
      Für alle Anfragen von Verbrauchern an Bookay gelten diese Allgemeinen Geschäftsbedingungen (AGB).
      <h3>Leistungsbeschreibung</h3>
      (1) Der Anbieter stellt eine Software zur Organisation eines schulischen Büchertauschs zur Verfügung. <br />
      (2) Die Software ermöglicht insbesondere das Anbieten, Suchen und Reservieren von Schulbüchern sowie die Kommunikation zwischen Nutzern.
      <br />
      (3) Der Anbieter ist berechtigt, Funktionen der Software weiterzuentwickeln oder anzupassen.
      <br />
      <h3>Registrierung und Nutzerkonto</h3>
      (1) Für die Nutzung der Plattform ist eine Registrierung erforderlich.
      <br />
      (2) Nutzer sind verpflichtet, wahrheitsgemäße Angaben zu machen.
      <br />
      (3) Zugangsdaten sind vertraulich zu behandeln und dürfen nicht an Dritte weitergegeben werden.
      <br />
      (4) Der Anbieter ist berechtigt, Nutzerkonten bei Verstößen gegen diese AGB zu sperren.
      <br />
      <h3>Nutzung der Plattform</h3>
      (1) Die Plattform darf ausschließlich für den schulischen Büchertausch genutzt werden.
      <br />
      (2) Es ist untersagt, rechtswidrige Inhalte einzustellen oder die Plattform für gewerbliche Zwecke zu nutzen.
      <br />
      (3) Nutzer sind selbst verantwortlich für die von ihnen eingestellten Inhalte und Buchangebote.
      <br />
      <h3>Haftung</h3>
      (1) Der Anbieter übernimmt keine Haftung für die von Nutzern eingestellten Inhalte, Buchangebote oder Kommunikation zwischen Nutzern.
      <br />
      (2) Der Anbieter haftet nur bei Vorsatz und grober Fahrlässigkeit.
      <br />
      (3) Für Datenverlust haftet der Anbieter nur im Falle vorsätzlichen oder grob fahrlässigen Handelns.
      <br />
      <h3>Verfügbarkeit</h3>
      Der Anbieter bemüht sich um eine möglichst unterbrechungsfreie Verfügbarkeit der Plattform, kann jedoch keine jederzeitige Erreichbarkeit
      garantieren.
      <br />
      <h3>Datenschutz</h3>
      Die Verarbeitung personenbezogener Daten erfolgt gemäß der Datenschutzerklärung und dem Auftragsverarbeitungsvertrag.
      <br />
      <h3>Schlussbestimmungen</h3>
      (1) Es gilt das Recht der Bundesrepublik Deutschland.
      <br />
      (2) Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
      <br />
    </Typography>
  </Paper>,
]

const AGB = () => {
  return (
    <>
      <Grid container spacing={5} sx={{ mt: 1 }}>
        <Main title="Allgemeine Geschäftsbedingungen" posts={posts} fullSize />
      </Grid>
    </>
  )
}

export default AGB
